import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const Count = styled.span`
  color: ${(props) => {
    if (props.value === 0) return "#E30B5C"
    if (props.value >= 1 && props.value <= 5) return "inherit"
    if (props.value > 5) return "#FF7518"
    return "red" // Default color if none of the conditions match
  }};
`

const ObjectCount = ({ value }) => {
  return <Count value={value}>{value}</Count>
}

ObjectCount.propTypes = {
  value: PropTypes.number,
}

export default ObjectCount
